<template>
  <zen-one :showuserinfo="false" title="" :crumbs="crumbs">
	  <z-page title="Pengagihan Semen">
      <div class="table_scrol">
        <div class="w-card__content content-hardcode mb3">
        <w-form v-model="valid" @validate="cari" ref="frm">
          <w-flex class="mt3">
            <w-input style="margin:5px; "
               v-model="pencarian.tarikh"
               type="date"
               label="Tarikh Agihan"
               />
            
             <w-input style="margin:5px; "
               v-model="pencarian.nama_penerima"
               label="Nama Penerima"
               />
          </w-flex>
        </w-form>

        <w-flex justify-end class="mt2">
                      <w-button class="mr2" v-on:click="resetPencarian()" v-on="on" bg-color="warning">
                    <w-icon class="mr1" md >fal fa-redo</w-icon>SET SEMULA
                </w-button>
                      <w-button class="mr2" bg-color="primary"  v-on="on" @click="$refs.frm.validate()">
                    <w-icon class="mr1" md >fal fa-search</w-icon>CARI
                </w-button>
        </w-flex>
      </div>
		  <z-table title="Senarai Pengagihan Semen" :headers="table.headers" :items="table.items" :meta="table.meta">
        <template #button v-if="$zutil.anyRole(['1', '3', '4', '11'])">
                      <w-button dark v-on="on" class="green--bg ml1" :route="$route('se.pengagihan.form',0)" >
                    <w-icon class="mr1" md >fal fa-plus</w-icon>TAMBAH
                </w-button>
          </template>
		    <template #header-label="{ header, label, index }">
            <template v-if="header.key == 'action'">
             <!--  <w-icon xs>fal fa-pencil</w-icon> -->
             Tindakan
            </template>
            <template v-else>
              {{ label }}
            </template>
          </template>
          <template #item-cell.action="{ item, label, header, index }">
            <!-- <w-flex class="flex justify-center">
            <w-button @click="papar(item)" class="w-button w-button--dark size--md info-dark1--bg"> 
              <w-icon xs class="mr2">fal fa-eye</w-icon>  Papar
            </w-button>
          </w-flex> -->
          <w-tooltip md top color="white" bg-color="black" >
                <template #activator="{ on }">
                      <w-button class="fs-2" v-on="on" v-if="item.pendaftar==0 && ($zutil.anyRole(['1', '3', '11']))" bg-color="error-dark1" dark tile @click="destroy1(item.id)"><div style="width: 6px"></div> 
                    <w-icon class="mr1" md >fal fa-trash</w-icon>
                </w-button>
                </template>
               PADAM
            </w-tooltip>
          </template>
           <template #item-cell.tarikh="{ item, label, header, index }">
              <w-flex class="flex justify-light">
                {{ item.tarikh }}
                 <!-- {{ $zutil.dateformat(item.tarikh)}} -->
              </w-flex>
           </template>
    	    </z-table>
        </div>
      </z-page>
    <!-- <w-dialog
        v-model="dialog.show"
        :fullscreen="dialog.fullscreen"
        width="1200"
        :persistent="dialog.persistent"
        :persistent-no-animation="dialog.persistentNoAnimation"
        title-class="primary-dark1--bg white">
        <template #title>
          <w-icon class="mr2">fal fa-cog</w-icon>
          Detail
        </template>
          <table >
            <tr class="row_data">
               <td><b>Tarikh Agihan</b></td>
               <td><b>:</b></td>
               <td>{{ $zutil.dateformat(form.tarikh)}}</td>
            </tr>
            <tr class="row_data">
               <td><b>Nama Penerima</b></td>
               <td><b>:</b></td>
               <td>{{form.nama}}</td>
            </tr>
          </table><br>
          <div class="table-responsive">
          <table class="w-table fixed-headers" style="height: 250px" valign="top">
            <thead>
                <tr>
                    <th class="w-table__header w-table__header--sortable text-center" width="1px">No</th>
                    <th class="w-table__header w-table__header--sortable text-center">No Permohonan</th>
                    <th class="w-table__header w-table__header--sortable text-center">Tarikh Permohonan</th>
                    <th class="w-table__header w-table__header--sortable text-center">Nama Pemohon</th>
                    <th class="w-table__header w-table__header--sortable text-center">Negeri Pemohon</th>
                    <th class="w-table__header w-table__header--sortable text-center">Kuantiti Mohon</th>
                    <th class="w-table__header w-table__header--sortable text-center">Kuantiti Lulus</th>
                    <th class="w-table__header w-table__header--sortable text-center">Kuantiti Tidak Lulus</th>
                    <th class="w-table__header w-table__header--sortable text-center">Status</th>
                    <th class="w-table__header w-table__header--sortable text-center">Tarikh Rekod</th>
                    <th class="w-table__header w-table__header--sortable text-center">Sudah Agih</th>
                    <th class="w-table__header w-table__header--sortable text-center">Agih</th>
                </tr>
            </thead>
           <tbody>
                  <tr v-for="(dt, index) in permohonan" :key="index">
                    <td class="w-table__cell text-center" width="1px">{{index+1}}</td>
                    <td class="w-table__cell text-left">{{dt.no_permohonan}}</td>
                    <td class="w-table__cell text-left">{{dt.tarikh}}</td>
                    <td class="w-table__cell text-left">{{dt.nama}}</td>
                    <td class="w-table__cell text-left">{{dt.lkpNegeri_label}}</td>
                    <td class="w-table__cell text-right">{{dt.kuantiti}}</td>
                    <td class="w-table__cell text-right">{{dt.kuantiti_lulus}}</td>
                    <td class="w-table__cell text-right">{{dt.kuantiti_tidak_lulus}}</td>
                    <td class="w-table__cell text-left">{{dt.lkpStatus_label}}</td>
                    <td class="w-table__cell text-left">{{dt.tarikh_rekod}}</td>
                    <td class="w-table__cell text-right">{{dt.jumlah_agih}}</td>
                    <td class="w-table__cell text-left"><w-input  type="number" v-model="dt.agih" @keyup="checkAgih(dt)" :maxlength="dt.agih"/></td>  
                  </tr>
           </tbody>
                  </table>
                </div>
              <w-form ref="form"  v-model="dialog.valid" @validate="submit" @success="success"></w-form>
            <template #actions>
          <div class="spacer" />
        <w-button bg-color="grey-light5--bg" @click="dialog.show = false">TUTUP</w-button>
      </template>
    </w-dialog> -->
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'

export default {
  extends: ZResource,
  props: {
    items: [Array, Object],
  },
  data() {
    return {
      resourceurl: 'se.pengagihan',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Pengurusan Semen Beku', route: '/se' },
        { label: 'Pengagihan Semen', route: '/se/pengagihan' },
      ],
      pencarian: {
         tarikh: '',
         nama_penerima: '',
         
      },
      tarikh: [],
      nama_penerima: [],
      dialog: {
        valid: false,
        show: false,
        fullscreen: false,
        persistent: true,
        persistentNoAnimation: false,
        loading: false,
        width: 900,
        item: {}
      },
      
    }
  },
  methods: {
    // cetak() {
    //   window.location.href = window.route('se.pengagihan.index')+'?no_permohonan='+this.pencarian.no_permohonan+'&name='+this.pencarian.name+'&status='+this.pencarian.status+'&cetak=1';
    // },
    papar(items){
      this.getData(items)
      this.dialog.show = true
    },
    getData(items){
      if(items.id > 0){
        this.$zcomm.get(this.api_service + 'pengagihan/show/'+items.id, {}).then(res => {
          this.form = res

        })
      }
    },

    cari() {
       if(!this.valid) return;

       let params = {
       ...this.pencarian,
       };
       params.page = 1;
       this.$inertia.visit(route(route().current(), params), {
           preserveState: true,
           preserveScroll: true,
       });
    },

    resetPencarian() {
       this.$inertia.visit(route(route().current()));
    },

    getKatalog(){
      this.$zcomm.get(this.api_service + 'lookup/id_ternakan', {}).then(res => {
        this.se_katalog = res
      })
    },
    destroy1(id)
    {
      this.$swal({
        title: 'Anda Pasti?',
        // text: "Are you sure want to delete this item!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ya',
        cancelButtonText: 'Tidak'
      }).then((result) => {
        if (result.value) {
          this.$zcomm.delete(this.resourceurl + '.destroy',id)
          .then(res => {
            this.sending = false;
            this.$inertia.visit(this.$page.url)
            this.removeitem(res) // remove the data from list. no need to refresh page
            if (typeof this.onAfterDelete === "function") {
              this.onAfterDelete()
            }
          })
          .finally(() => {
            // $('#' + this.resourceurl).modal('hide')
          });
        }else{ }
        })

    },
  
  },

  watch: {

  },
  mounted() {
    this.getKatalog();
    // override default setting
    this.dialog.width = 500
      
  },
}
</script>
